module.exports = __webpack_public_path__ + "img/gift-item.b7cb9470.png";